// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Video Page Styles */
.video-page {
  background: #fff;
}

.video-card {
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.video-card:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.video-thumbnail {
  position: relative;
  height: 180px;
  overflow: hidden;
}

.video-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-placeholder {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  background: rgba(65, 58, 164, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  transition: all 0.3s ease;
}

.play-icon:hover {
  background: rgba(65, 58, 164, 1);
  transform: translate(-50%, -50%) scale(1.1);
}

.video-info {
  background: white;
}

.video-info h5 {
  font-size: 16px;
  margin-bottom: 10px;
  color: #333;
}

.video-info p {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .video-thumbnail {
    height: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/video.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Video Page Styles */\r\n.video-page {\r\n  background: #fff;\r\n}\r\n\r\n.video-card {\r\n  border: 1px solid #eee;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  transition: all 0.3s ease;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.video-card:hover {\r\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.video-thumbnail {\r\n  position: relative;\r\n  height: 180px;\r\n  overflow: hidden;\r\n}\r\n\r\n.video-thumbnail img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.video-placeholder {\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #f5f5f5;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #666;\r\n}\r\n\r\n.play-icon {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 50px;\r\n  height: 50px;\r\n  background: rgba(65, 58, 164, 0.8);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n  font-size: 20px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.play-icon:hover {\r\n  background: rgba(65, 58, 164, 1);\r\n  transform: translate(-50%, -50%) scale(1.1);\r\n}\r\n\r\n.video-info {\r\n  background: white;\r\n}\r\n\r\n.video-info h5 {\r\n  font-size: 16px;\r\n  margin-bottom: 10px;\r\n  color: #333;\r\n}\r\n\r\n.video-info p {\r\n  font-size: 14px;\r\n  color: #666;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .video-thumbnail {\r\n    height: 150px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
